import React from 'react'

import classnames from 'classnames'
import styles from './styles.module.less'

export const IconWithText = ({ icon, text, className, ...props }) => {
  return (
    <div {...props} className={classnames(styles.wrapper, className)}>
      {icon}
      <span>{text}</span>
    </div>
  )
}
